import { useAuth0 } from '@auth0/auth0-react';

/**
 * useAuth0のラッパー
 */
export const useAuth = () => {
  return useAuth0();
};
